/**
 * Serve the engine's 3D models and shared sprites from our own origin.
 *
 * Upstream hardcodes `https://oldschool-cdn.com/` in Assets.getAssetUrl (with a TODO
 * admitting it should be a build variable). That CDN sends no Access-Control-Allow-Origin
 * header at all, so `fetch` from any origin other than infernotrainer.com is blocked
 * outright — the game cannot start. `scripts/fetch-assets.mjs` mirrors the files into the
 * build output instead; this points the loader at them.
 *
 * The body is upstream's, with only the base URL changed, so the preload bookkeeping that
 * onAssetProgress / checkAssetsLoaded depend on behaves identically.
 *
 * MUST be imported before any module that calls getAssetUrl at module scope (i.e. before
 * InfernoRegion), because webpack evaluates the import graph depth-first.
 */
import { Assets } from "osrs-sdk";

/** Relative, so it resolves under the game's document root (/inferno-game/). */
const BASE = "";

Assets.getAssetUrl = function getAssetUrl(asset: string): string {
  const url = `${BASE}${asset}`;
  if (Assets.loadedAssets[url]) {
    return url;
  }
  Assets.loadingAssetUrls.push(url);
  Assets.assetCount++;
  Promise.resolve().then(async () => {
    try {
      const response = await fetch(url);
      await response.arrayBuffer();
    } catch (err) {
      // Don't strand the loading screen on one bad asset — the gate is
      // loadingAssetUrls reaching empty, so a failure still has to clear itself.
      console.error(`Failed to preload asset: ${url}`, err);
    }
    Assets.onProgressFns.forEach((onProgress) =>
      onProgress(Assets.assetCount - Assets.loadingAssetUrls.length, Assets.assetCount),
    );
    Assets.loadingAssetUrls = Assets.loadingAssetUrls.filter((u: string) => u !== url);
    Assets.loadedAssets[url] = true;
  });
  return url;
};
